
import Component from '../../../assets/scripts/modules/component';
import {pagination} from '../../../assets/scripts/modules/pagination';

const Swiper = require('swiper/dist/js/swiper.min');

class PhotoSlider extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.container = this.element.querySelector('.swiper-container');
    this.pagination = this.element.querySelector('.swiper-pagination');
    this.buttonPrev = this.element.querySelector('.swiper-button--prev');
    this.buttonNext = this.element.querySelector('.swiper-button--next');

    this.instance = null;

    window.requestAnimationFrame(() => this.initSwiper());

  }

  initSwiper() {

    const forceLoadImage = instance => {
      const slide = instance.slides[instance.activeIndex];
      const image = slide.querySelector('.picture, .background-image');

      try {
        if (!image.classList.contains('has-loaded')) {
          image.forceLoad();
        }
      } catch(e) {
        //
      }
    };

    this.instance = new Swiper(this.container, {
      autoPlay: false,
      controlBy: 'container',
      direction: 'horizontal',
      effect: 'slide',
      grabCursor: false,
      loop: false,
      nextButton: this.buttonNext,
      paginationClickable: true,
      paginationElement: 'span',
      prevButton: this.buttonPrev,
      pagination: {
        el: this.pagination,
        clickable: true,
        type: 'custom',
        renderCustom: pagination,
      },
      resistanceRatio: 0,
      roundLengths: true, // Prevents dragging fuzzyness
      setWrapperSize: true, // Fix for Firefox / IE11 for flex icm. padding-bottom
      slidesPerView: 1,
      spaceBetween: 0,
      touchRatio: 1,
      onTransitionStart: forceLoadImage,
      onTransitionEnd: forceLoadImage,
    });

  }

}

for (const element of document.querySelectorAll('.photo-slider')) {
  element.instance = new PhotoSlider('photo-slider', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/photo-slider/photo-slider.js